



















































import Vue from 'vue';

function parseTime(timeString: string): { hour: number, minute: number, isPM: boolean } | undefined {
    if (timeString) {
        const regex = /(\d+):(\d+)/gm;
        let match = regex.exec(timeString);
        if (!match) {
            return;
        }
        let hour = +match[1];
        let minute = +match[2];

        const isPM = hour >= 12;
        hour = hour > 12 ? hour - 12 : hour;
        if (hour === 0) {
            hour = 12;
        }

        return { hour, minute, isPM};
    }
}

export default Vue.component('time-picker-control', {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: { type: String, required: false, default: '00:00' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      showDropdown: false,
      isPM: false,
      isHourFocus: true,
      selectedMinute: null as any,
      selectedMinuteOld: null as any,
      selectedHour: null as any,
      selectedHourOld: null as any,
      latestePinRotationClass: 'tp__cell--rotate-40',
      minutes: [
        { value: '05', class: 'tp__cell--rotate-10', isSelected: false },
        { value: '10', class: 'tp__cell--rotate-20', isSelected: false },
        { value: '15', class: 'tp__cell--rotate-30', isSelected: false },
        { value: '20', class: 'tp__cell--rotate-40', isSelected: false },
        { value: '25', class: 'tp__cell--rotate-50', isSelected: false },
        { value: '30', class: 'tp__cell--rotate-60', isSelected: false },
        { value: '35', class: 'tp__cell--rotate-70', isSelected: false },
        { value: '40', class: 'tp__cell--rotate-80', isSelected: false },
        { value: '45', class: 'tp__cell--rotate-90', isSelected: false },
        { value: '50', class: 'tp__cell--rotate-100', isSelected: false },
        { value: '55', class: 'tp__cell--rotate-110', isSelected: false },
        { value: '00', class: 'tp__cell--rotate-120', isSelected: false },
      ],
      hours: [
        { value: '1', class: 'tp__cell--rotate-10', isSelected: false },
        { value: '2', class: 'tp__cell--rotate-20', isSelected: false },
        { value: '3', class: 'tp__cell--rotate-30', isSelected: false },
        { value: '4', class: 'tp__cell--rotate-40', isSelected: false },
        { value: '5', class: 'tp__cell--rotate-50', isSelected: false },
        { value: '6', class: 'tp__cell--rotate-60', isSelected: false },
        { value: '7', class: 'tp__cell--rotate-70', isSelected: false },
        { value: '8', class: 'tp__cell--rotate-80', isSelected: false },
        { value: '9', class: 'tp__cell--rotate-90', isSelected: false },
        { value: '10', class: 'tp__cell--rotate-100', isSelected: false },
        { value: '11', class: 'tp__cell--rotate-110', isSelected: false },
        { value: '12', class: 'tp__cell--rotate-120', isSelected: false },
      ],
      noPinAnimation: false,
    }
  },
  created: function () {
    this.selectHour(this.hours[6], false);
    this.selectMinute(this.minutes[11]);
  },
  filters: {
    ampm (timeString: string): string {
        const parsedTime = parseTime(timeString);
        if (parsedTime) {
            const minute = ('0' + parsedTime.minute).slice(-2);
            return parsedTime.hour + ':' + minute + (parsedTime.isPM ? ' PM' : ' AM');
        }
        return '';
    }
  },
  methods: {
    setIsPM (boo: boolean) {
      this.isPM = boo;
    },
    setIsHourFocus (boo: boolean) {
      this.isHourFocus = boo;
      this.latestePinRotationClass = boo ? this.selectedHour.class : this.selectedMinute.class;
    },
    selectMinute (minute: any) {
      this.selectedMinute = minute;
      this.minutes.forEach(function (minute) {
        minute.isSelected = false;
      })
      minute.isSelected = true;
      this.noPinAnimation = true;
      this.latestePinRotationClass = minute.class;
      let self = this;
      setTimeout(function () {
        self.noPinAnimation = false;
      },50);
    },
    selectHour (hour: any, changeToMinuteClock: boolean = true) {
      this.selectedHour = hour;
      this.hours.forEach(function (hour) {
        hour.isSelected = false;
      })
      hour.isSelected = true;
      this.noPinAnimation = true;
      this.latestePinRotationClass = hour.class;
      let self = this;
      setTimeout(function () {
        self.noPinAnimation = false;
        if (changeToMinuteClock) {
          self.setIsHourFocus(false);
        }
      },50);
    },
    initializeTimePicker () {
        const parsedTime = parseTime(this.modelValue);
        if (parsedTime) {
            this.setIsPM(parsedTime.isPM);
            for (const hr of this.hours) {
                if (Number(hr.value) === parsedTime.hour) {
                    this.selectHour(hr, false);
                    break;
                }
            }
            for (const min of this.minutes) {
                if (Number(min.value) === parsedTime.minute) {
                    this.selectMinute(min);
                    break;
                }
            }
        }
    },
    saveTime () {
      // Establishing military time
      let hourValue = '00';
      if (!this.isPM) {
        if (Number(this.selectedHour.value) === 12) {
          hourValue = '00';
        } else {
          hourValue = ('0' + this.selectedHour.value).slice(-2)
        }
      } else {
        if (Number(this.selectedHour.value) === 12) {
          hourValue = '12';
        } else {
          hourValue = '' + (Number(this.selectedHour.value) + 12);
        }
      }
      this.$emit('change', hourValue + ':' + this.selectedMinute.value);
      this.toggleControl();
    },
    cancel () {
      this.selectedMinute = this.selectedMinuteOld;
      this.selectedHour = this.selectedHourOld;
      this.selectMinute(this.selectedMinute);
      this.selectHour(this.selectedHour);
      this.toggleControl();
    },
    toggleControl () {
      if (this.disabled) { return; }
      this.showDropdown = !this.showDropdown;
      let self = this;
      if (this.showDropdown) {
        // Initialize the Time picker with the current time input attribute
        this.initializeTimePicker();

        this.selectedMinuteOld = this.selectedMinute;
        this.selectedHourOld = this.selectedHour;

        this.setIsHourFocus(true);
      } else {
        setTimeout(function () {
          self.setIsHourFocus(true);
        }, 300);
      }
    },

  }
});
